module.exports = __webpack_public_path__ + "media/src/images/partners/pfur-ff07338c2c196618b5f141aa08959991.jpg";